import React, { Component } from "react";

export default class ChartErrorBoundary extends Component {
  constructor (props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch (error, errorInfo) {
    // TODO: log this
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex flex-grow-1 justify-content-center align-items-center">
          <p className="lead">Unable to display the chart</p>
        </div>
      );
    }

    return this.props.children;
  }
}